"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "countryCodes", {
  enumerable: true,
  get: function () {
    return _constants.countryCodes;
  }
});
exports.getPhoneNumberParts = exports.getCountryIndexByISOCode = exports.getCountryIndexByCode = void 0;
Object.defineProperty(exports, "requiredZipCountryCodes", {
  enumerable: true,
  get: function () {
    return _constants.requiredZipCountryCodes;
  }
});
var _constants = require("./constants");
const SORTED_PHONE_CODES = _constants.countryCodes.map(_ref => {
  let {
    phoneCode
  } = _ref;
  return String(phoneCode);
}).sort((a, b) => b.length - a.length);
const COUNTRY_CODE_MATCHER = new RegExp(`^\\+(${SORTED_PHONE_CODES.join('|')})`);
const getCountryIndexByCode = code => {
  return _constants.countryCodes.findIndex(_ref2 => {
    let {
      phoneCode
    } = _ref2;
    return String(phoneCode) === String(code);
  });
};
exports.getCountryIndexByCode = getCountryIndexByCode;
const getCountryIndexByISOCode = isoCountryCode => {
  return _constants.countryCodes.findIndex(_ref3 => {
    let {
      isoCountryCode: code
    } = _ref3;
    return code === isoCountryCode;
  });
};
exports.getCountryIndexByISOCode = getCountryIndexByISOCode;
const getPhoneNumberParts = phoneNumber => {
  const phoneWithoutCountryCode = phoneNumber.replace(COUNTRY_CODE_MATCHER, '');
  const phoneCode = phoneNumber.match(COUNTRY_CODE_MATCHER)?.[0]?.replace('+', '');
  return {
    phoneCode,
    phoneWithoutCountryCode
  };
};
exports.getPhoneNumberParts = getPhoneNumberParts;